import builder from '../builder';
import HospitalFirstAid from '../../streamline-icons/light/hospital-first-aid.svg';

export default builder('IconHospitalFirstAidLight', HospitalFirstAid);
